import { Card } from "antd";
import externalLink from "assets/icons/external-link.svg";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "redux/hooks";
import KeyDates from "components/common/key-dates";
import Restricted from "components/common/restricted";
import { PERMISSIONS } from "permissions/app-permissions";
import styles from "./styles.module.scss";
import { Env } from "utils/Types";

export default function AccessSchemesCard() {
  const { env } = useAppSelector(state => state.globalUI);
  const { t } = useTranslation();
  const { isSrsOpen, srsClosingDate, isEasOpen, easClosingDate, isSrsOpenOS, srsClosingDateOS } =
    useAppSelector(state => state.properties.closingData);
  const isOS = env === Env.INTERNATIONAL;

  return (
    <Card
      className={["padding-top-mobile", styles["access-schemes-card"]].join(" ")}
      title={
        <div className={styles["access-schemes-card_title"]}>
          <span className="show-desktop">{t("dashboard.accessScheme.desktop-title")}</span>
          <span className="hide-desktop">{t("dashboard.accessScheme.help-links")}</span>
        </div>
      }
      headStyle={{
        borderBottom: "1px solid rgba(217, 217, 217, 0.3)"
      }}
    >
      <div className="show-desktop">
        {isOS ? (
          <KeyDates
            isOpen={isSrsOpenOS}
            title={t("dashboard.accessScheme.srs-label")}
            closingDate={srsClosingDateOS}
            marginBtm={16}
          />
        ) : (
          <KeyDates
            isOpen={isSrsOpen}
            title={t("dashboard.accessScheme.srs-label")}
            closingDate={srsClosingDate}
            marginBtm={16}
          />
        )}

        <Restricted to={PERMISSIONS.DASHBOARD.INFO_BOX.EAS}>
          <KeyDates
            isOpen={isEasOpen}
            title={t("dashboard.accessScheme.eas-label")}
            closingDate={easClosingDate}
            marginBtm={24}
          />
        </Restricted>

        <div style={{ marginBottom: 16 }}>
          <p className={styles["access-schemes-card_subtitle"]}>
            {t("dashboard.accessScheme.help-links")}
          </p>
        </div>
      </div>

      <div>
        <a
          href={t("dashboard.accessScheme.links.how-to-rate.link") || ""}
          target="_blank"
          className={styles["access-schemes-card__link-container"]}
          aria-label={t("dashboard.accessScheme.links.how-to-rate.aria-label") || ""}
        >
          {t("dashboard.accessScheme.links.how-to-rate.label")}
          <img src={externalLink} alt={""} />
        </a>
      </div>

      <Restricted to={PERMISSIONS.DASHBOARD.INFO_BOX.HT_FILL_EIS_FORM}>
        <div>
          <a
            href={t("dashboard.accessScheme.links.ht-fill-eis-form.link") || ""}
            target="_blank"
            className={styles["access-schemes-card__link-container"]}
            aria-label={t("dashboard.accessScheme.links.ht-fill-eis-form.aria-label") || ""}
          >
            {t("dashboard.accessScheme.links.ht-fill-eis-form.label")}
            <img src={externalLink} alt={""} />
          </a>
        </div>
      </Restricted>

      <div>
        <a
          href={t("dashboard.accessScheme.links.help-guide.link") || ""}
          target="_blank"
          className={styles["access-schemes-card__link-container"]}
          aria-label={t("dashboard.accessScheme.links.help-guide.aria-label") || ""}
        >
          {t("dashboard.accessScheme.links.help-guide.label")}
          <img src={externalLink} alt={""} />
        </a>
      </div>
    </Card>
  );
}
